/**
 * @file Automatically generated by barrelsby.
 */

export * from './is-authenticated.guard';
